function EmbedWidgetContent() {
  return (
    <div className="">EmbedWidgetContent</div>
  )
}

export default EmbedWidgetContent;
